/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/SentryErrorBoundary/SentryErrorBoundaryFallback/SignOutAction/Content"
  
}) {
let errorOnClickSignOutValueData = fromData.useDataValue({ viewPath,
context: 'error',
path: 'onClickSignOut',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 type="primary"
 size="small"
 marginTop={dtSpaceXs}
 data="error.onClickSignOut"
 onClick={errorOnClickSignOutValueData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Sign out"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}